import _ from 'lodash';
import { compose } from 'redux';

import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

export const getOBCustomFieldsConfig = compose(fillConfigFieldsWithKeys, fields => {
  const groupedFields = _.groupBy(fields, 'submissionForm');
  const isSingleGroup = _.size(groupedFields) === 1;

  return {
    groups: _.map(groupedFields, (fields, key) => ({
      type: FieldType.GROUP,
      fields,
      customStyles: {
        marginBottom: '15px',
      },
      key,
      title: isSingleGroup
        ? null
        : {
            label: key,
            titleStyles: {
              fontSize: '16px',
              marginBottom: '4px',
              color: ({ palette }) => palette.text.primary,
            },
          },
    })),
  };
});
